"use strict";

exports.__esModule = true;
exports.NotificationsWrapper = exports.NotificationsToolbar = exports.NotificationTitleText = exports.NotificationTitle = exports.NotificationMessageText = exports.NotificationMessage = exports.NotificationLine = exports.NewNotificationDotWrapper = void 0;
var _Theme = require("../../Theme");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var NotificationLine = exports.NotificationLine = _styledComponents["default"].section.withConfig({
  displayName: "styles__NotificationLine",
  componentId: "sc-cbv8jm-0"
})(["& > *{margin:0 0 5px 0;padding:0;}cursor:pointer;padding:5px;:not(:last-child){border-bottom:2px solid ", ";}"], function () {
  return (0, _Theme.val)("toolbarBorderColor");
});
var NotificationsWrapper = exports.NotificationsWrapper = _styledComponents["default"].aside.withConfig({
  displayName: "styles__NotificationsWrapper",
  componentId: "sc-cbv8jm-1"
})(["max-width:500px;min-width:100px;min-height:50px;max-height:700px;overflow:auto;background:", ";color:", ";"], function () {
  return (0, _Theme.val)("ToolbarBackground");
}, function () {
  return (0, _Theme.val)("ToolbarTextColor");
});
var NotificationMessage = exports.NotificationMessage = _styledComponents["default"].span.withConfig({
  displayName: "styles__NotificationMessage",
  componentId: "sc-cbv8jm-2"
})(["& > *:first-child{max-width:310px;}display:flex;align-items:flex-end;justify-content:space-between;"]);
var NotificationMessageText = exports.NotificationMessageText = _styledComponents["default"].span.withConfig({
  displayName: "styles__NotificationMessageText",
  componentId: "sc-cbv8jm-3"
})(["white-space:nowrap;text-overflow:ellipsis;overflow:hidden;margin-right:5px;"]);
var NotificationTitle = exports.NotificationTitle = _styledComponents["default"].span.withConfig({
  displayName: "styles__NotificationTitle",
  componentId: "sc-cbv8jm-4"
})(["& > *:first-child{max-width:310px;}*{margin:0;}display:flex;align-items:center;justify-content:space-between;"]);
var NotificationTitleText = exports.NotificationTitleText = _styledComponents["default"].h3.withConfig({
  displayName: "styles__NotificationTitleText",
  componentId: "sc-cbv8jm-5"
})(["white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"]);
var NewNotificationDotWrapper = exports.NewNotificationDotWrapper = _styledComponents["default"].svg.withConfig({
  displayName: "styles__NewNotificationDotWrapper",
  componentId: "sc-cbv8jm-6"
})(["width:10px;height:10px;position:", ";right:25px;"], function (_ref) {
  var _ref$position = _ref.position,
    position = _ref$position === void 0 ? "relative" : _ref$position;
  return position;
});
var NotificationsToolbar = exports.NotificationsToolbar = (0, _styledComponents["default"])(_Core.Toolbar).withConfig({
  displayName: "styles__NotificationsToolbar",
  componentId: "sc-cbv8jm-7"
})(["background:none;padding-left:5px;padding-right:0;"]);